var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-extend-menu-section-contents" },
    _vm._l(_vm.fileList, function (file) {
      return _c("RoomChatForm", {
        key: file.roomFileId,
        attrs: {
          type: "file",
          section: _vm.section,
          menuList: _vm.menuList(file),
          item: _vm.itemObj(file),
          hideDownload: _vm.isUploading,
        },
        on: {
          onClickDownload: function ($event) {
            return _vm.handleClickDownloadFile(file)
          },
          onClickDelete: _vm.onClickDelete,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }